import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function AutoSqP({ open, onClose, user, reload }) {
  const [newValueCashDeposit, setnewValueCashDeposit] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = useCallback(async () => {
    if (!newValueCashDeposit.trim()) {
      toast.error("Cash Deposit cannot be empty");
      return;
    }

    // ❗ Validate numeric value
    const num = Number(newValueCashDeposit);
    if (isNaN(num)) {
      toast.error("Please enter a valid number");
      return;
    }

    // ❗ Cannot exceed 99%
    if (num > 99) {
      toast.error("Auto Sq (%) cannot be more than 99%");
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user.id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      auto_sqp: num,

      nsemargin: user.margin_nse,
      nsecashmargin: user.margin_nse_cash,
      mcxmargin: user.margin_mcx,
      optionsmargin: user.margin_options,
      comexmargin: user.margin_comex,
      cryptomargin: user.margin_crypto,
      forexmargin: user.margin_forex,
      usstockmargin: user.margin_us_stock,
      sgxmargin: user.margin_sgx,
      indexmargin: user.margin_index,
    };

    try {
      const response = await backend.edit_user_margin_level(payload);
      if (response.error === "False") {
        toast.success(response.message);
        reload?.();
        onClose?.();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network Error, Failed to update. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [newValueCashDeposit]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-[var(--background)] border-2 border-[var(--hover)]  rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <h2 className="text-lg font-bold text-[var(--text)]">
          ✏️ Edit Auto Sq (%)
        </h2>

        <input
          type="number"
          value={newValueCashDeposit}
          onChange={(e) => setnewValueCashDeposit(e.target.value)}
          className="mt-4 w-full bg-[var(--background)] text-[var(--text)] border-1 border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder="Enter Auto Sq (%)"
          min="1"
          max="99"
        />

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--sell)] text-[var(--white)] transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--primary)] text-white transition"
          >
            {isLoading ? "Loading.." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
